import { Component, Input } from '@angular/core';

import { Termin } from '../../model/termin';


@Component({
  selector: 'termin-input',
  templateUrl: 'termin-input.html'
})
export class TerminInput {

  @Input() title: string;
  @Input() termin: Termin;

}



// WEBPACK FOOTER //
// ./src/components/termin-input/termin-input.component.ts